import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import L from 'leaflet'
import { useQuery } from '@apollo/client';
import { GET_LOCATIONS } from '../../Graphql/queries/getQueries';
import Spiner from '../Spiner/Spiner';
function GetIcon(_iconSize, forecast) {
    return L.icon({
        iconUrl: require('../../assets/Marker.png'),
        iconSize: [_iconSize],
    });
}


const RegionMap = ({ data, loading }) => {
    const LocationsData = data?.Leads?.nodes?.map((item) => ({ latLng: [item.location_lat, item.location_lon], name: item.region }))
    if (loading) return <Spiner />
    return (
        <>
            <MapContainer
                style={{
                    width: '100%',
                    height: '100%',
                    paddingRight: 10
                }}
                center={[0, 0]}
                zoom={2}
                scrollWheelZoom={true}

            // dragging={false}
            >
                <TileLayer
                    noWrap={true}
                    // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                // url="https://{s}.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                />
                {loading ? '' : LocationsData.map((mark, i) => (
                    <Marker key={i} position={mark.latLng} icon={GetIcon(10)}
                        eventHandlers={{
                            mouseover: (event) => event.target.openPopup(),
                        }}>

                        <Popup style={{ background: 'red' }}>
                            {mark.name}
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>

        </>
    )
}

export default RegionMap